import Stack from '@mui/material/Stack';

import GenerateIconZone from '@webclient/components/upload/components/generate-icon-zone';
import UploadZone from '@webclient/components/upload/components/upload-zone';
import {
  StyledButtonBase,
  StyledUploadZoneStack,
} from '@webclient/components/upload/styles';

type Props = {
  onGenerateIconZoneClick: VoidFunction;
  handleDrop: (files: File[]) => void;
  handleRedirectToCropImageStep: VoidFunction;
  Header?: React.ReactNode;
  Footer?: React.ReactNode;
};

export default function Upload({
  handleDrop,
  handleRedirectToCropImageStep,
  onGenerateIconZoneClick,
  Header,
  Footer,
}: Props) {
  return (
    <Stack>
      {Header}
      <StyledUploadZoneStack>
        <StyledButtonBase
          disableRipple
          disableTouchRipple
        >
          <UploadZone
            handleDrop={handleDrop}
            handleRedirectToCropImageStep={handleRedirectToCropImageStep}
          />
        </StyledButtonBase>
        <StyledButtonBase
          onClick={onGenerateIconZoneClick}
          disableRipple
          disableTouchRipple
        >
          <GenerateIconZone />
        </StyledButtonBase>
      </StyledUploadZoneStack>
      {Footer}
    </Stack>
  );
}
